import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useFilterRecentlyModified } from "@hooks/use-catalog";
import Input from "@components/core/Input";

function FilterRadio({
  id = "",
  label = "",
  filterType = "",
  filterSectionKey = "",
  item = {},
  onClick = () => {},
}) {
  const filterRecentlyModified = useFilterRecentlyModified();

  function handleClick() {
    const eventData = { button: "filter", filter: filterType, value: item.label };
    ahoy("$click", eventData);
    analytics.track("$click", eventData);

    filterRecentlyModified(filterSectionKey);

    onClick();
  }

  const labelCount = item.count ? ` (${item.count})` : "";

  return (
    <Input
      id={id}
      type="radio"
      label={`${label}${labelCount}`}
      checked={item.isRefined}
      onClick={handleClick}
      readOnly
      className="p-3 bg-white border-bottom"
      rightToLeft
      fullWidth
    />
  );
}

export default FilterRadio;
